import { Component,Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'app/api.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ApprovalTimelineDialogComponent } from 'app/components/approval-timeline/approval-timeline-dialog.component';
import { ApprovalTimelineData } from 'app/components/approval-timeline/approval-timeline.component';
import { QualityCheckFileModalComponent } from '../quality-check-file-modal/quality-check-file-modal.component';
import { DocumentTracingModalComponent } from 'app/components/document-tracing-modal/document-tracing-modal.component';
import { MatSelect } from '@angular/material/select';
import { ViewChild } from '@angular/core';
import { ReOpenService } from 'app/reopen.service';
import { CancelApprovalService } from 'app/cancel-approval.service';
import { UiPanelAction, UiPanelMode, UiApprovalStep } from 'app/shared/ui/models/ui-document-panel.model';
import { UiBadgeVariant } from 'app/shared/ui/models/ui-badge.model';
import { UiUnsavedChangesDialogComponent, UnsavedChangesResult } from 'app/shared/ui/document-panel/ui-unsaved-changes-dialog/ui-unsaved-changes-dialog.component';
import { UI_DOCUMENT_PANEL_BREADCRUMBS } from 'app/shared/ui/document-panel/document-panel.config';

@Component({
  selector: 'app-create-quality-check-dialog',
  templateUrl: './create-quality-check-dialog.component.html',
  styleUrls: ['./create-quality-check-dialog.component.scss'],
  host: { class: 'ui-document-panel-host' },
})
export class CreateQualityCheckDialogComponent {

  date: any;
  grn: any;
  previousGrn: any;
  grn_data: any[] = [];
  productList: any[] = [];
  rfq_id: any;
  maxDate: string = '';
  quality_check_no: any;
  vendordata: any;
  selectedBranch: any;
  vendor: any;
  branch:any;
  previousBranch: any;
  vendorid: any;
  selectedBranchName: string = '';
  selectedBranchId:any;
  image_data: any;
  type: any;
  fullhostname: any;
  uploadedFiles: any[] = [];

  remark:any;
  isUpdateMode: boolean = false;
  isView: boolean = false;
  panelMode: UiPanelMode = 'create';
  enteredEditFromView = false;
  editSnapshot: string | null = null;
  user_id: any;
  readonly breadcrumb = UI_DOCUMENT_PANEL_BREADCRUMBS.qualityCheck;
  profitCostData: any[];
  section_data: any[];
  profitcost: any;
  section: any;
  allSections: any[];
  is_reverse: boolean = false;
  grnOffset = 0;
  grnLimit = 100;
  grnHasMore = true;
  loadingGrn = false;
  grnSearch = '';
  profitCostOffset = 0;
  profitCostLimit = 100;
  profitCostHasMore = true;
  loadingProfitCost = false;
  profitCostSearch = '';
  @ViewChild('profitCostSelect') profitCostSelect!: MatSelect;
  @ViewChild('grnSelect') grnSelect!: MatSelect;
  constructor(
    private apiService: ApiService,
    public dialogRef: MatDialogRef<CreateQualityCheckDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private reopenService: ReOpenService,
    private cancelApprovalService: CancelApprovalService,
  ) {
    const userString = localStorage.getItem('data');
    const user = JSON.parse(userString) || {};
    this.user_id = user?.id;
    console.log('hello', this.data);
    console.log('data type',this.data?.type);
    this.type = this.data?.type|| 'create';
    this.grn = this.data?.grn_id || null;
    this.quality_check_no = this.data?.qc_no || null;
   // this.date = this.data?.date || null;
    this.remark=this.data?.remark || null;
    this.fetchProfitSection(this.grn, true); 
    // this.profitcost = this.data?.profit_cost_id || null;
    if (Array.isArray(this.data?.profit_cost_id)) {
      this.profitcost = [...new Set(this.data.profit_cost_id.filter((id: any) => id != null).map(Number))];
    } else if (this.data?.profit_cost_id) {
      this.profitcost = String(this.data.profit_cost_id).split(',').map(Number);
    } else {
      this.profitcost = null;
    }
    this.previousGrn = this.grn;
    console.log('date qc', this.date)
    this.vendorData();
     if (this.data?.type === 'reverse') {
        this.is_reverse = true;
      } else {
        this.is_reverse = false;
      }
      this.initPanelMode();
  }

  ngOnInit(): void {
   const today = new Date();
    this.date = this.formatDate(today);
    this.maxDate = this.formatDate(today);
    this.fetchQcProductList(); // Fetch if not provided
    this.vendorData();
     if (this.data?.date ) {
      this.date = this.data?.date;
    }
    if (this.panelMode === 'edit') {
      this.editSnapshot = this.captureEditSnapshot();
    }
  }
   formatDate(date: Date): string {
    return date.toISOString().split('T')[0];
  }
  // fetchQcNo(){
  //   this.apiService.getQualityCheckNo().subscribe(
  //     (response) => {
  //       this.quality_check_no = response.quality_check_no;
  //     },
  //     (error) => {
  //       console.error('Error fetching data:', error);
  //     }
  //   );
  // }
  // onGrnChange() {
  //   if (this.data && Object.keys(this.data).length === 0) {
  //     this.fetchProductList();
  //     //this.fetchQcNo();  
  //   }
  // }
  onSectionChange() {
    console.log('data', this.data);
    if (this.section) {
      if (this.data.id && Number(this.grn) === Number(this.data.grn_id)) {
        this.fetchQcProductList();
      } else {
        this.fetchProductList();
      }
    }
  }

  fetchQcProductList(): void {
    this.apiService.showQualityCheckById(this.data.id).subscribe(
      (response) => {
        this.productList = response.data;
        console.log('Fetched qc Product List:', this.productList);
        if (response.uploaded_files && response.uploaded_files.length > 0) {
          this.uploadedFiles = response.uploaded_files.map((file: any) => ({
            ...file,
            preview: `${this.fullhostname}/api/storage/${file.image}`
          }));
          console.log('update response', response.uploaded_files);
        } else {
          this.uploadedFiles = [];
        }
      },
      (error) => {
        console.error('Error fetching qc products:', error);
        this.productList = [];
      }
    );
  }
   fetchProductList(): void {
    console.log('Grn ID:', this.grn);
    this.apiService.GrnById(this.grn,this.section,this.profitcost).subscribe(
      (response) => {
        this.productList = response.data;
        console.log('Fetched grn Product List:', this.productList);
      },
      (error) => {
        console.error('Error fetching grn products:', error);
        this.productList = [];
      }
    );
  }
  getTitle(): string {
    return this.panelTitle;
  }

  get isInputDisabled(): boolean {
    return this.panelMode === 'view' || this.is_reverse;
  }

  private initPanelMode(): void {
    if (this.data?.type === 'View') {
      this.panelMode = 'view';
      this.isView = true;
      this.isUpdateMode = true;
    } else if (this.data?.type === 'Update' || this.data?.type === 'reverse') {
      this.panelMode = this.data?.type === 'reverse' ? 'edit' : 'edit';
      this.isView = false;
      this.isUpdateMode = true;
    } else {
      this.panelMode = 'create';
      this.isView = false;
      this.isUpdateMode = false;
    }
  }

  get panelTitle(): string {
    if (this.is_reverse) {
      return 'Reverse Quality Check';
    }
    switch (this.panelMode) {
      case 'create': return 'Create Quality Check';
      case 'edit': return 'Edit Quality Check';
      case 'view': return 'View Quality Check';
      default: return 'Quality Check';
    }
  }

  get statusLabel(): string {
    if (!this.data?.id) {
      return 'Draft';
    }
    return this.data.approval_status || 'Open';
  }

  get statusVariant(): UiBadgeVariant {
    const status = this.data?.approval_status;
    if (!this.data?.id || status == null || status === 'Open') {
      return 'default';
    }
    if (status === 'Approved') return 'approved';
    if (status === 'Pending') return 'pending';
    if (status === 'Rejected') return 'rejected';
    return 'default';
  }

  get approvalSteps(): UiApprovalStep[] {
    const status = this.data?.approval_status;
    const steps: UiApprovalStep[] = [
      { id: 'draft', label: 'Draft', icon: 'edit_note', state: 'upcoming' },
      { id: 'pending', label: 'Pending Approval', icon: 'schedule', state: 'upcoming' },
      { id: 'approved', label: 'Approved', icon: 'check_circle', state: 'upcoming' },
    ];
    if (!this.data?.id) {
      steps[0].state = 'active';
      return steps;
    }
    if (status == null || status === 'Open') {
      steps[0].state = 'active';
    } else if (status === 'Pending') {
      steps[0].state = 'completed';
      steps[1].state = 'active';
    } else if (status === 'Approved') {
      steps[0].state = 'completed';
      steps[1].state = 'completed';
      steps[2].state = 'completed';
    } else if (status === 'Rejected') {
      steps[0].state = 'completed';
      steps[1].state = 'rejected';
    }
    return steps;
  }

  canEdit(): boolean {
    if (this.is_reverse) {
      return false;
    }
    const status = this.data?.approval_status;
    return status == null || status === 'Open' || status === 'Rejected';
  }

  enterEditMode(): void {
    if (!this.canEdit()) {
      return;
    }
    this.enteredEditFromView = true;
    this.panelMode = 'edit';
    this.isView = false;
    this.isUpdateMode = true;
    if (this.data) {
      this.data.type = 'Update';
    }
    this.editSnapshot = this.captureEditSnapshot();
  }

  enterViewMode(): void {
    this.panelMode = 'view';
    this.isView = true;
    this.isUpdateMode = true;
    this.enteredEditFromView = false;
    this.editSnapshot = null;
    if (this.data) {
      this.data.type = 'View';
    }
  }

  private captureEditSnapshot(): string {
    return JSON.stringify({
      grn: this.grn ?? null,
      date: this.date ?? null,
      vendor: this.vendor ?? null,
      branch: this.branch ?? null,
      profitcost: this.profitcost ?? null,
      section: this.section ?? null,
      remark: this.remark ?? null,
      productList: this.productList ?? [],
    });
  }

  hasUnsavedChanges(): boolean {
    if (this.panelMode !== 'edit' || !this.editSnapshot) {
      return false;
    }
    return this.captureEditSnapshot() !== this.editSnapshot;
  }

  private restoreFromSnapshot(): void {
    if (!this.editSnapshot) {
      return;
    }
    const snapshot = JSON.parse(this.editSnapshot);
    this.grn = snapshot.grn;
    this.date = snapshot.date;
    this.vendor = snapshot.vendor;
    this.branch = snapshot.branch;
    this.profitcost = snapshot.profitcost;
    this.section = snapshot.section;
    this.remark = snapshot.remark;
    this.productList = snapshot.productList || [];
  }

  onClose(): void {
    this.handleExitIntent('close');
  }

  onCancel(): void {
    if (this.panelMode === 'edit' && this.enteredEditFromView) {
      this.handleExitIntent('view');
      return;
    }
    this.handleExitIntent('close');
  }

  private handleExitIntent(intent: 'close' | 'view'): void {
    if (this.panelMode === 'edit' && this.hasUnsavedChanges()) {
      this.promptUnsavedChanges(intent);
      return;
    }
    this.executeExitIntent(intent);
  }

  private executeExitIntent(intent: 'close' | 'view'): void {
    if (intent === 'view') {
      this.enterViewMode();
    } else {
      this.dialogRef.close();
    }
  }

  private promptUnsavedChanges(intent: 'close' | 'view'): void {
    const promptRef = this.dialog.open(UiUnsavedChangesDialogComponent, {
      width: '440px',
      disableClose: true,
      panelClass: 'ui-unsaved-changes-dialog',
    });
    promptRef.afterClosed().subscribe((result: UnsavedChangesResult | undefined) => {
      if (!result || result === 'cancel') {
        return;
      }
      if (result === 'discard') {
        this.restoreFromSnapshot();
        this.executeExitIntent(intent);
        return;
      }
      if (result === 'save') {
        this.save(intent);
      }
    });
  }

  get footerPrimaryActions(): UiPanelAction[] {
    if (this.panelMode === 'view') {
      return this.canEdit()
        ? [{ id: 'edit', label: 'Edit', icon: 'edit', variant: 'primary', visible: true }]
        : [];
    }
    return [
      {
        id: 'save',
        label: 'Save',
        icon: 'save',
        variant: 'success',
        visible: true,
      },
      {
        id: 'send-approval',
        label: 'Send for Approval',
        icon: 'send',
        variant: 'primary',
        visible: !!this.data?.id && this.canEdit() && !this.is_reverse,
      },
    ];
  }

  get footerSecondaryActions(): UiPanelAction[] {
    return [
      {
        id: 'tracing',
        label: 'Document Tracing',
        icon: 'account_tree',
        variant: 'outline',
        visible: !!this.data?.id && this.panelMode !== 'view',
      },
      {
        id: 'timeline',
        label: 'Approval Timeline',
        icon: 'timeline',
        variant: 'outline',
        visible: !!this.data?.id &&
          (this.data.approval_status === 'Pending' ||
            this.data.approval_status === 'Rejected' ||
            this.data.approval_status === 'Approved') &&
          this.panelMode !== 'view',
      },
      {
        id: 'cancel',
        label: this.panelMode === 'view' ? 'Close' : 'Cancel',
        icon: 'close',
        variant: 'ghost',
        visible: true,
      },
    ];
  }

  get footerDestructiveAction(): UiPanelAction | null {
    if (this.panelMode !== 'view' || this.user_id !== 1 || !this.data?.id) {
      return null;
    }
    return { id: 'delete', label: 'Delete', icon: 'delete', variant: 'danger', visible: true };
  }

  get footerOverflowActions(): UiPanelAction[] {
    if (this.panelMode !== 'view' || !this.data?.id) {
      return [];
    }
    const status = this.data.approval_status;
    return [
      { id: 'tracing', label: 'Document Tracing', icon: 'account_tree', visible: true },
      {
        id: 'timeline',
        label: 'Approval Timeline',
        icon: 'timeline',
        visible: status === 'Pending' || status === 'Rejected' || status === 'Approved',
      },
      { id: 'reopen', label: 'Reopen', icon: 'replay', visible: status === 'Approved' && this.user_id === 1 },
      {
        id: 'cancel-approval',
        label: 'Cancel Approval',
        icon: 'cancel',
        visible: status === 'Pending' && this.user_id === 1,
      },
      {
        id: 'reverse',
        label: 'Reverse',
        icon: 'undo',
        visible: status === 'Approved' && !this.is_reverse,
      },
    ];
  }

  onFooterAction(actionId: string): void {
    switch (actionId) {
      case 'save':
        this.save();
        break;
      case 'send-approval':
        this.sendForApprove();
        break;
      case 'tracing':
        if (this.data?.id) {
          this.viewRelatedDocuments(this.data.id);
        }
        break;
      case 'timeline':
        this.showApprovalTimeline();
        break;
      case 'edit':
        this.enterEditMode();
        break;
      case 'delete':
        this.deleteQualityCheck();
        break;
      case 'reopen':
        this.onReopen();
        break;
      case 'cancel-approval':
        this.onCancelApproval();
        break;
      case 'reverse':
        this.openReverseMode();
        break;
      case 'cancel':
        this.onCancel();
        break;
    }
  }

  deleteQualityCheck(): void {
    if (!this.data?.id) {
      return;
    }
    this.apiService.deleteQualityCheck(this.data.id).subscribe(
      (response) => {
        alert(response.message);
        this.dialogRef.close({ id: this.data.id, action: 'delete' });
      },
      (error) => {
        alert(error.error?.message);
      }
    );
  }

  onReopen(): void {
    if (!this.data?.id) {
      return;
    }
    this.reopenService.reopen(this.data.id, 'QualityCheck', () => {
      this.data.approval_status = 'Open';
      this.enterViewMode();
    });
  }

  onCancelApproval(): void {
    if (!this.data?.id) {
      return;
    }
    this.cancelApprovalService.cancelApproval(this.data.id, 'QualityCheck', () => {
      this.data.approval_status = 'Open';
      this.enterViewMode();
    });
  }

  openReverseMode(): void {
    if (!this.data?.id) {
      return;
    }
    this.apiService.showQualityCheckById(this.data.id).subscribe(
      (response) => {
        const qcData = response.data;
        this.is_reverse = true;
        this.panelMode = 'edit';
        this.isView = false;
        this.data.type = 'reverse';
        this.productList = qcData;
        this.editSnapshot = this.captureEditSnapshot();
      },
      (error) => {
        console.error('Error loading QC for reverse:', error);
      }
    );
  }
  
  openQcFileShowModal() {
    if (this.data.id) {
      this.apiService.getQcFiles(this.data.id).subscribe(
        (response) => {
          this.image_data = response.uploadedFiles;
          console.log('Qc file data:', this.image_data);
  
          this.dialog.open(QualityCheckFileModalComponent, { 
            width: '1200px',
            height: '600px',
            data: {
              id: this.data.id,
              images: this.image_data
            }
          });
        },
        (error) => {
          console.error("Error fetching GRN files:", error);
        }
      );
    } else {
      console.error("Invalid GRN ID.");
    }
  }

 onFileSelected(event: any): void {
  const files: FileList = event.target.files;

  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    const reader = new FileReader();

    reader.onload = (e: any) => {
        console.log('Reader result:', e.target.result); 
      this.uploadedFiles.push({
        file: file,
        name: file.name,
        preview: e.target.result
      });
    };

    reader.readAsDataURL(file);
  }
}

isImage(file: any): boolean {
  const filePath = file?.image || file?.name || '';
  return typeof filePath === 'string' && (
    filePath.toLowerCase().endsWith('.png') ||
    filePath.toLowerCase().endsWith('.jpg') ||
    filePath.toLowerCase().endsWith('.jpeg')
  );
}

isPDF(file: any): boolean {
  const filePath = file?.image || file?.name || '';
  return typeof filePath === 'string' && filePath.toLowerCase().endsWith('.pdf');
}
isPreviewable(extension: string): boolean {
  return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'pdf'].includes(extension);
}


removeFile(index: number): void {
  this.uploadedFiles.splice(index, 1);
}
  save(exitAfterSave: 'close' | 'view' = 'view'): void {
    const selectedGrn = this.grn_data?.find(item => item.id === this.grn);
      const grnNo = selectedGrn ? selectedGrn.grn_no : this.grn;
      console.log('this.productList',this.productList)
    if (this.productList && this.productList.length > 0) {
      for (const product of this.productList) {
        if (!product.details || product.details.length === 0) {
          alert(`No details found in this GRN (${grnNo})`);
          return;
        }
        for (const detail of product.details) {
          const pendingQty = this.isUpdateMode
            ? this.getInitialTotal(detail)
            : detail?.receive_qty - detail?.pass_qty_sum;
          if (detail.pass_qty > pendingQty) {
            alert(`Pass Quantity (${detail.pass_qty}) cannot be greater than Pending Quantity (${pendingQty}) for SKU: ${detail.sku?.sku_name}`);
            return;
          }
          // if (detail.receive_qty < detail.pass_qty) {
          //   alert(`Receive Quantity (${detail.receive_qty}) cannot be greater than Pass Quantity (${detail.pass_qty}) for SKU: ${detail.stock_keeping?.sku_name}`);
          //   return;
          // }
        }
      }
    }
    const postData = {
      grn_id: this.grn,
      quality_check_no: this.quality_check_no || null,
      date: this.date,
      vendor_id: this.vendor,
      vendor_branch: this.branch,
      profit_cost_id:this.profitcost,
      section_id: this.section,
       uploaded_files: this.uploadedFiles,
       document_type: 'QualityCheck',
      remark:this.remark,
      type:this.type,
      products: this.productList.map(product => ({
        vendor_id: product.vendor.id,
        vendor_branch_id: product.vendor_branch.id,
        details: product.details.map(detail => ({
          sku_id: detail.item_service_type === 'SKU'
            ? detail.sku?.id
            : detail.item_service_type === 'Service'
              ? detail.service?.id
              : detail.item_service_type === 'Fixed Asset'
                ? detail.fa_template?.id
                : null,
          specification: detail.specification,
          description: detail.description,
          quantity: detail.qty,
          hsn_no: detail.hsn_no,
          unit_id: detail.unit.id,
          start_date: detail.start_date,
          end_date: detail.end_date,
          price: detail.price,
          receive_qty: detail.receive_qty,
          delivery_date: detail.delivery_date,
          pass_qty:detail.pass_qty ?? 0,
          item_service_type:detail.item_service_type,
          level_no: detail.level_no, 
          reverse_qty: detail.reverse_qty,   
          grn_id:detail.grn_id,
          quality_check_id:detail.quality_check_id,
          grn_details_id:this.data.id ? detail.grn_details_id : detail.id,
          profit_cost_id:detail.profit_cost_id,
          section_id:detail.section_id,                                                                                                             
        }))
      }))
    };
  
    console.log('Post Data:', postData); 
      //  return;
    if (this.data?.id) {
      this.apiService.updateQualityCheck(this.data.id, postData).subscribe(
        response => {
          console.log('Quality check updated successfully:');
          alert('Quality check updated successfully');
          if (exitAfterSave === 'close') {
            this.dialogRef.close({ id: this.data.id, action: 'update' });
          } else {
            this.enterViewMode();
          }
        },
        error => {
          console.error('Error updating Requisition:', error);
        }
      );
    } else {
    this.apiService.createQualityCheck(postData).subscribe(
      response => {
        this.dialogRef.close({ id: response.data.id, action: 'create' });
         alert('Quality check Created successfully');
      },
      error => {
        console.error('Error saving data:', error);
      }
    );
  }
  }
  allowOnlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.key;
    if ((charCode >= '0' && charCode <= '9') || charCode === '.') {
      return true;
    }
    event.preventDefault();
    return false;
  }
  vendorData() {
    this.apiService.vendorOfGrn().subscribe(
      (response) => {
        this.vendordata = response;
        if (this.data?.vendor_data) {
          this.vendor = this.data.vendor_data;
          this.getVendorBranch(this.vendor);
          this.branch = this.data.branch_id || null;
        }
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }
  
  getVendorBranch(VendorId: number []) {
    this.apiService.getbranch(VendorId).subscribe(
      (response) => {
        this.selectedBranch = response.data;
        if (this.data?.branch_id) {
          this.branch = this.data.branch_id;
          this.fetchpo(VendorId, this.branch);
        }
      },
      (error) => {
        console.error("Error fetching branch data:", error);
      }
    );
  }
  
  // fetchpo(vendor_id: any,branch_id:any) {
  //   this.grn_data = [];
  //    this.vendorid = vendor_id;
  //    if (!this.data?.id) {
  //    const selectedVendor = this.vendordata.find(item => item.vendor_id === vendor_id);
  //    this.selectedBranchName = selectedVendor ? selectedVendor.vendor_branch_name : '';
  //    this.selectedBranchId = selectedVendor ? selectedVendor.vendor_branch_id : '';
  //    }
  //    console.log('vendor id ', this.vendorid)
  //    const postData = {
  //      vendor_id: this.vendorid,
  //      branch_id:branch_id
  //    };
  //    this.apiService.getGrnForQc(postData).subscribe(
  //      (response) => {
  //        if (!response || response.length === 0) {
  //          console.log('No purchase orders found.');
  //          return;
  //        }
  //        this.grn_data = response;
  //        console.log('grn_data',this.grn_data);
  //        if (this.data?.grn_id) {
  //         const matched = this.grn_data.find(item => item.id === this.data.grn_id);
  //         if (matched) {
  //           this.grn = matched.id;
  //           this.onGrnChange();
  //         }
  //       }
  //      },
  //      (error) => {
  //        console.error('Error fetching data:', error);
  //      }
  //    );
  //  }
  fetchpo(vendor_id: any,branch_id: any,params?: 
    {
      offset?: number;
      limit?: number;
      search?: string;
    }) {
    if (params?.offset === undefined) {
      this.grn_data = [];
      this.grnOffset = 0;
      this.grnHasMore = true;
    }


    this.vendorid = vendor_id;

    if (!this.data?.id) {
      const selectedVendor = this.vendordata.find(item => item.vendor_id === vendor_id);
      this.selectedBranchName = selectedVendor ? selectedVendor.vendor_branch_name : '';
      this.selectedBranchId = selectedVendor ? selectedVendor.vendor_branch_id : '';
    }
    console.log('vendor id ', this.vendorid);
    if (params?.offset !== undefined && this.loadingGrn) return;
    this.loadingGrn = true;
    const postData: any = {
      vendor_id: this.vendorid,
      branch_id: branch_id
    };

    if (params?.search) {
      postData.search = params.search;
    }

    if (params?.offset !== undefined && params?.limit !== undefined) {
      postData.offset = params.offset;
      postData.limit = params.limit;
      postData.type = 'lazyloading';
    }

    this.apiService.getGrnForQc(postData).subscribe(
      (response: any[]) => {
        const data = response || [];

        if (!data.length && params?.offset === undefined) {
          console.log('No purchase orders found.');
          this.loadingGrn = false;
          return;
        }

        if (params?.offset !== undefined) {

          this.grn_data = this.grn_data ?? [];

          this.grn_data = [...this.grn_data, ...data];
          const limit = params.limit ?? this.grnLimit;
          if (data.length < limit) {
            this.grnHasMore = false;
          }

          this.grnOffset += data.length;
        } else {
          this.grn_data = data;
          this.grnOffset = data.length;

          this.grn_data = this.grn_data ?? [];
          if (this.data?.grn_id) {
            const matched = data.find(
              item => item.id === this.data.grn_id
            );

            if (matched) {
              this.grn = matched.id;
              this.onSectionChange();
            }
          }
        }

        this.loadingGrn = false;
      },
      error => {
        console.error('Error fetching data:', error);
        this.loadingGrn = false;
      }
    );
  }


   fetchProfitSection(grnId: number, isInitial: boolean = false) {
    if (!grnId) {
    return;
    }
    if (this.loadingProfitCost || !this.profitCostHasMore) {
    return;
  }
  this.loadingProfitCost = true;
    if (this.previousGrn && this.previousGrn !== grnId && (this.productList && this.productList.length > 0)) {
        if (!confirm('Changing GSRN will clear selected profit cost, section and product details. Do you want to continue?')) {
            setTimeout(() => { this.grn = this.previousGrn; });
            return;
        }
    }
    this.previousGrn = grnId;
    this.profitcost = null;
    this.section = null;
    this.productList = [];
  const postData = { grn_id: grnId ,offset: this.profitCostOffset, limit: this.profitCostLimit,search: this.profitCostSearch || undefined};
  this.apiService.getProfitSectionByGrn(postData).subscribe(
    (response) => {
      // this.profitCostData = response.profit_cost_centers || [];
    const data = response.profit_cost_centers || [];
    if (this.profitCostOffset === 0) {
      this.profitCostData = data;
    } else {
      this.profitCostData = [...this.profitCostData, ...data];
    }
    this.profitCostOffset += data.length;
    this.profitCostHasMore = data.length >= this.profitCostLimit;
      this.allSections = response.sections || [];

      console.log('QC ProfitCost:', this.profitCostData, 'QC Sections:', this.allSections);
         if (this.profitcost) {
        this.filterSectionsByProfitCost(this.profitcost, isInitial);
      }
      this.loadingProfitCost = false;  
    },
    (error) => {
      this.loadingProfitCost = false;
      console.error('Error fetching profit cost and sections for QC:', error);
    }
  );
}

filterSectionsByProfitCost(profitCostId: number, isInitial: boolean = false) {
    // this.section = null;
  // this.section_data = this.allSections.filter(
  //   (s: any) => s.profit_cost_id == profitCostId
  // );
  this.section_data = this.allSections.filter((s: any) => {
    if (Array.isArray(profitCostId)) {
      return profitCostId.includes(s.profit_cost_id) || profitCostId.includes(Number(s.profit_cost_id));
    }
    return s.profit_cost_id == profitCostId;
  });
  if(this.data?.id && isInitial){
    console.log('update section',this.data.id);
     //  this.section = this.data?.section_id || null;
    if (Array.isArray(this.data?.section_id)) {
      this.section = [...new Set(this.data.section_id.filter((id: any) => id != null).map(Number))];
    } else if (this.data?.section_id) {
      this.section = String(this.data.section_id).split(',').map(Number);
    } else {
      this.section = [];
    }
  }
  // this.section = null;
}

   sendForApprove() {
    console.log('Send for approval');
    const requestData = {
      document_type: 'QualityCheck',
      document_id: this.data.id,
      profit_cost_id:this.profitcost?.[0],
    };
    this.apiService.sendForApproval(requestData).subscribe(
      (response) => {
        console.log('Send for approval response:', response);
        alert('Document sent for approval');
        this.dialogRef.close({ data: this.data.id, action: 'approvalsend' });
      },
      (error) => {
        console.error('Error sending for approval:', error);
        alert('Error sending for approval' + error.error.message);
      }
    );
  }

  showApprovalTimeline() {
    const requestData = {
      document_type: 'QualityCheck',
      document_id: this.data.id,
    };

    this.apiService.getApprovalTimeline(requestData).subscribe(
      (response) => {
        console.log('Approval timeline data:', response);
        
        // Open approval timeline dialog with real data
        const dialogRef = this.dialog.open(ApprovalTimelineDialogComponent, {
          width: '800px',
          height: '600px',
          disableClose: true,
          data: { approvalData: response.data || response }
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log('Approval timeline dialog closed:', result);
        });
      },
      (error) => {
        console.error('Error fetching approval timeline:', error);
        
        // Fallback to demo data if API fails
        const demoApprovalData: ApprovalTimelineData = {
          document_id: this.data.id || 12345,
          document_type: 'QualityCheck',
          current_stage: 2,
          total_stages: 4,
          overall_status: 'pending',
          created_at: new Date().toISOString(),
          created_by: 'Current User',
          rejection_count: 1,
          last_rejected_level: 1,
          rejected_by: 'john.doe@company.com',
          rejected_by_name: 'John Doe',
          stages: [
            {
              id: 1,
              name: 'Department Head Review',
              level: 1,
              status: 'approved',
              approver_name: 'Sarah Johnson',
              approved_at: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
              comments: 'All requirements met, approved for next level',
              timeline: [],
              pending_time_seconds: 0,
              pending_time_formatted: '0s',
              cancellation_count: 0
            },
            {
              id: 2,
              name: 'Finance Manager Review',
              level: 2,
              status: 'pending',
              is_current: true,
              timeline: [],
              pending_time_seconds: 7200,
              pending_time_formatted: '2h 0m 0s',
              cancellation_count: 0
            },
            {
              id: 3,
              name: 'General Manager Approval',
              level: 3,
              status: 'not_started',
              timeline: [],
              pending_time_seconds: 0,
              pending_time_formatted: '0s',
              cancellation_count: 0
            },
            {
              id: 4,
              name: 'Final Approval',
              level: 4,
              status: 'not_started',
              timeline: [],
              pending_time_seconds: 0,
              pending_time_formatted: '0s',
              cancellation_count: 0
            }
          ]
        };

        const dialogRef = this.dialog.open(ApprovalTimelineDialogComponent, {
          width: '800px',
          height: '600px',
          disableClose: true,
          data: { approvalData: demoApprovalData }
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log('Approval timeline dialog closed:', result);
        });
      }
    );
  }

  viewRelatedDocuments(qcId: number): void {
    const payload = {
      document_id: qcId,
      document_type: "quality_check"
    };

    // Show loading state
    const loadingDialog = this.dialog.open(DocumentTracingModalComponent, {
      width: '90%',
      maxWidth: '1200px',
      height: '80%',
      maxHeight: '800px',
      disableClose: false,
      data: {
        tracingData: null,
        loading: true
      }
    });

    this.apiService.getDocumentTracing(payload).subscribe(
      (response) => {
        if (response.status) {
          // Close loading dialog and open with data
          loadingDialog.close();

          const dialogRef = this.dialog.open(DocumentTracingModalComponent, {
            width: '90%',
            maxWidth: '1200px',
            height: '80%',
            maxHeight: '800px',
            disableClose: false,
            data: {
              tracingData: {
                ...response.data,
                document_type: "quality_check",
                current_document: response.data.current_document || `QC${qcId}` // Ensure current document is set
              },
              loading: false
            }
          });

          dialogRef.afterClosed().subscribe(() => {
            console.log('Document tracing modal closed');
          });
        } else {
          loadingDialog.close();
          alert('Error: ' + response.message);
        }
      },
      (error) => {
        loadingDialog.close();
        console.error('Error fetching document tracing:', error);

        let errorMessage = 'Error fetching related documents. Please try again.';
        if (error.error && error.error.message) {
          errorMessage = error.error.message;
        } else if (error.message) {
          errorMessage = error.message;
        }

        alert(errorMessage);
      }
    );
  }  
  getInitialTotal(detail: any) {
  if (!detail.initial_total_qty) {
    detail.initial_total_qty = (detail.receive_qty - detail.pass_qty_sum) + detail.pass_qty ;
  }
  return detail.initial_total_qty;
}
  onReverseQtyChange(detail: any) {

    // Save original only once
    if (detail.original_pass_qty === undefined) {
      detail.original_pass_qty = Number(detail.pass_qty);
    }

    const reverse = Number(detail.reverse_qty) || 0;

    // Calculate new receive
    let newReceive = detail.original_pass_qty - reverse;

    // Stop negative receive
    if (newReceive < 0) {
      alert("Reverse quantity cannot be more than receive quantity!");
      detail.reverse_qty = '';
      return;
    }

    detail.pass_qty = newReceive;

    console.log("Reverse:", reverse, "Pass Qty:", detail.pass_qty);
  }
  onGrnOpen(opened: boolean) {
    if (!opened) return;
    if (!this.vendorid || !this.selectedBranchId) {
      console.warn('GRN open blocked: vendor or branch missing');
      return;
    }

    this.grn_data = [];
    this.grnOffset = 0;
    this.grnHasMore = true;
    this.grnSearch = '';

    this.fetchpo(this.vendorid, this.selectedBranchId, {
      offset: this.grnOffset,
      limit: this.grnLimit
    });

    Promise.resolve().then(() => {
      const panel = this.grnSelect.panel?.nativeElement;
      if (!panel) return;

      panel.removeEventListener('scroll', this.onGrnScroll);
      panel.addEventListener('scroll', this.onGrnScroll);
    });
  }
  onGrnSearch(value: string) {
    if (!this.vendorid || !this.selectedBranchId) {
      console.warn('GRN search blocked: vendor or branch missing');
      return;
    }

    this.grnSearch = value || '';
    this.grnOffset = 0;
    this.grnHasMore = true;
    this.grn_data = [];

    this.fetchpo(this.vendorid, this.selectedBranchId, {
      offset: this.grnOffset,
      limit: this.grnLimit,
      search: this.grnSearch
    });
  }
  onGrnScroll = (event: any) => {
    if (!this.vendorid || !this.selectedBranchId) return;

    const panel = event.target as HTMLElement;

    if (
      panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 20 &&
      this.grnHasMore &&
      !this.loadingGrn
    ) {
      this.fetchpo(this.vendorid, this.selectedBranchId, {
        offset: this.grnOffset,
        limit: this.grnLimit,
        search: this.grnSearch
      });
    }
  };
  onProfitCostSearch(value: string) {
  this.profitCostSearch = value || '';
  this.profitCostOffset = 0;
  this.profitCostHasMore = true;

  this.fetchProfitSection(this.grn, true);
}
onProfitCostOpen(opened: boolean) {
  if (!opened || !this.grn) {
    return;
  }
  this.profitCostOffset = 0;
  this.profitCostHasMore = true;
  this.fetchProfitSection(this.grn, true);
  Promise.resolve().then(() => {
    const panel = this.profitCostSelect?.panel?.nativeElement;
    if (!panel) return;
    panel.removeEventListener('scroll', this.onProfitCostScroll);
    panel.addEventListener('scroll', this.onProfitCostScroll);
  });
}
onProfitCostScroll = (event: any) => {
  const panel = event.target as HTMLElement;
  if (
    panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 20 &&
    this.profitCostHasMore &&
    !this.loadingProfitCost
  ) {
    this.fetchProfitSection(this.grn, true);
  }
};
}
